<div class="card-body p-3">

    <div class="row">
        <div class="col-md-3">
            <app-benef-info [beneficiaireAutOselect]="beneficiaireAutOselect">
                <app-search-form (sendUserInfo)="onSetUserInfo($event)"></app-search-form>
            </app-benef-info>
        </div>
        <div class="col col-md-9" [class.section-disabled]="!itemBeneficiare?.id">

            <!-- ── Header ── -->
            <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="aservir-title">
                    <i class="fas fa-tooth me-1"></i>Actes prescrits
                    <span class="aservir-count ms-1" *ngIf="itemsPrescription?.length">
                        {{ itemsPrescription.length }} acte(s)
                    </span>
                </span>
                <button class="btn btn-success btn-sm" (click)="showPresModal = true">
                    <i class="fas fa-file-medical me-1"></i>Nouvelle prescription
                </button>
            </div>

            <!-- ── Table prescriptions ── -->
            <div class="table-responsive">
                <table class="table table-sm table-hover aservir-table mb-0">
                    <thead>
                        <tr>
                            <th style="width:30px" class="text-center">
                                <a style="cursor:pointer" (click)="getItemsPrescriptionActe()" title="Actualiser">
                                    <i class="fa fa-redo-alt"></i>
                                </a>
                            </th>
                            <th>Acte</th>
                            <th style="width:160px">Dent(s) / Diagnostic</th>
                            <th style="width:68px" class="text-end">Qté</th>
                            <th style="width:110px" class="text-center">Option</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsPrescription; let indice = index" [ngClass]="{
                            'option-background-orange': item.is_entente_prealable && item.is_eligible !== false,
                            'option-background-red':    item.is_exclu && item.is_eligible !== false,
                            'option-background-green':  !item.is_exclu && !item.is_entente_prealable && item.is_eligible !== false,
                            'medoc-replacer': item.is_replacer,
                            'disabled-row':   item.is_eligible === false
                        }">
                            <td class="text-center text-muted">{{ indice + 1 }}</td>
                            <td>
                                {{ item.acte_libelle }}
                                <span *ngIf="item.is_eligible === false" class="badge bg-secondary ms-1" style="font-size:0.63rem;cursor:help" title="Acte prescrit par référence : ce prestataire n'est pas autorisé à l'exécuter directement">Référé</span>
                            </td>
                            <td style="font-size:0.78rem;color:#555">
                                <span *ngIf="item.diagnostic">{{ item.diagnostic }}</span>
                                <span *ngIf="!item.diagnostic">{{ item.zone_affectee || '—' }}</span>
                            </td>
                            <td class="text-end">{{ item.quantite | IntegerFormatPipe }}</td>
                            <td class="text-center">
                                <div class="d-flex gap-1 justify-content-center align-items-center">
                                    <button *ngIf="canAdd(item) && item.is_eligible !== false"
                                        (click)="addItemToList(item)"
                                        class="btn btn-xs btn-primary">
                                        <i class="fas fa-plus me-1"></i>Ajouter
                                    </button>
                                    <span *ngIf="item.is_exclu" class="status-pill status-exclu">
                                        <i class="fas fa-ban"></i>Non garanti
                                    </span>
                                    <span *ngIf="item.is_entente_prealable && !item.is_traite" class="status-pill status-attente">
                                        <i class="fas fa-clock"></i>Attente préalable
                                    </span>
                                    <span *ngIf="item.is_entente_prealable && item.is_traite" class="status-pill status-rejete">
                                        Rejeté
                                    </span>
                                    <button class="btn btn-xs btn-outline-info ms-1" (click)="openChatDialog(item)" title="Discuter">
                                        <i class="fa fa-comments"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="!itemsPrescription?.length">
                            <td colspan="5" class="text-center text-muted py-3">
                                <i class="fas fa-info-circle me-2"></i>Aucune donnée disponible
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- ── Section actes à exécuter ── -->
            <div class="aservir-header mt-2">
                <span class="aservir-title" style="color:#0665aa">
                    <i class="fas fa-stethoscope me-1"></i>Actes à exécuter
                </span>
                <span class="aservir-count" *ngIf="itemsPrescriptionAservir?.length" style="background:#0665aa">
                    {{ itemsPrescriptionAservir.length }} acte(s)
                </span>
            </div>
            <div class="table-responsive">
                <table class="table table-sm table-hover aservir-table mb-0">
                    <thead>
                        <tr>
                            <th style="width:30px" class="text-center"><i class="fa fa-redo-alt"></i></th>
                            <th>Acte</th>
                            <th style="width:68px" class="text-end">Qté</th>
                            <th style="width:88px" class="text-end">Montant</th>
                            <th style="width:88px" class="text-end text-warning">Part patient</th>
                            <th style="width:88px" class="text-end text-success">Part assurance</th>
                            <th style="width:58px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsPrescriptionAservir; let indice = index">
                            <td class="text-center text-muted">{{ indice + 1 }}</td>
                            <td>{{ item.acte_libelle }}</td>
                            <td class="text-end">{{ item.quantite }}</td>
                            <td class="text-end fw-semibold">{{ item.montant | IntegerFormatPipe }}</td>
                            <td class="text-end text-warning fw-semibold">
                                <a *ngIf="item.message_explicatif" (click)="showMessageExplicatif(item)"
                                    class="text-warning" style="cursor:pointer;text-decoration:underline">
                                    {{ (item.part_patient || 0) | IntegerFormatPipe }}
                                </a>
                                <span *ngIf="!item.message_explicatif">{{ (item.part_patient || 0) | IntegerFormatPipe }}</span>
                            </td>
                            <td class="text-end text-success fw-semibold">{{ (item.part_assurance || 0) | IntegerFormatPipe }}</td>
                            <td class="text-center">
                                <button (click)="removeMedicamentFromList(item)" class="btn btn-xs btn-outline-danger" title="Retirer">
                                    <i class="fas fa-times"></i>
                                </button>
                            </td>
                        </tr>
                        <tr class="aservir-total-row" *ngIf="itemsPrescriptionAservir?.length">
                            <td colspan="3" class="text-end fw-bold">Total</td>
                            <td class="text-end fw-bold">{{ getTotal() | IntegerFormatPipe }}</td>
                            <td class="text-end text-warning fw-bold">{{ getTotalPartPatient() | IntegerFormatPipe }}</td>
                            <td class="text-end text-success fw-bold">{{ getTotalPartAssurance() | IntegerFormatPipe }}</td>
                            <td></td>
                        </tr>
                        <tr *ngIf="!itemsPrescriptionAservir?.length">
                            <td colspan="7" class="text-center text-muted py-3">
                                <i class="fas fa-info-circle me-2"></i>Aucune donnée disponible
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- ── Alerte dépassement ── -->
            <div class="mt-2" *ngIf="itemToSave.montant_depassement && itemToSave.montant_depassement > 0">
                <div class="alert alert-danger text-center font-weight-bold shadow-lg p-4 rounded"
                    style="font-size: 1.2rem; border: 2px solid #dc3545;">
                    ⚠️ {{itemToSave.message_depassement}}
                    <hr class="my-3" style="border-color: #fff;">
                    <div class="text-left" style="font-size: 1rem;">
                        <p><strong>Nouveaux montants :</strong></p>
                        <p>💰 Part patient : <span class="text-danger" style="font-weight: 700;">{{itemToSave.part_patient | IntegerFormatPipe}} FCFA</span></p>
                        <p>🏥 Part assurance : <span class="text-success" style="font-weight: 700;">{{itemToSave.part_assurance | IntegerFormatPipe}} FCFA</span></p>
                    </div>
                    <div class="mt-3">
                        <button (click)="confirmSaveItem(itemToSave)" class="btn btn-outline-light btn-lg shadow-sm" style="font-weight:bold; background:gray">
                            Souhaitez-vous continuer ?
                        </button>
                    </div>
                </div>
            </div>

            <!-- ── Soumettre ── -->
            <div class="mt-2">
                <button (click)="onActeDeepSeek()" [disabled]="!itemsPrescriptionAservir?.length"
                    class="btn btn-primary btn-sm w-100">
                    <i class="fas fa-paper-plane me-1"></i>Soumettre vente
                </button>
            </div>

        </div>
    </div>

</div>

<!-- ── Modal nouvelle prescription ── -->
<div class="my-modal-overlay" *ngIf="showPresModal" (click)="showPresModal = false">
    <div class="my-modal" (click)="$event.stopPropagation()">
        <div class="my-modal-header d-flex justify-content-between align-items-center">
            <strong>Nouvelle prescription — Dentisterie</strong>
            <button class="my-close-btn" (click)="showPresModal = false">&times;</button>
        </div>
        <div class="my-modal-body">
            <app-form-pres-dentisterie
                [matricule]="itemBeneficiare?.matricule"
                [praticienId]="itemBeneficiare?.praticien_id"
                (onPrescriptionSaved)="onPrescriptionSaved()">
            </app-form-pres-dentisterie>
        </div>
    </div>
</div>
